module.exports = __webpack_public_path__ + "static/img/Acer_VN7_591G.5d6c5734.png";